import React from 'react'
import { Route } from 'react-router-dom'

import useStore from '../../hooks/useStore'

import MapNav from './MapNav'
import TimelineNav from './TimelineNav'
import ScreenNav from './ScreenNav'
import LanguageNav from './LanguageNav'

import { MainNav, ContentNav } from './Navigation.styles'

const Navigation = () => {
  const { state } = useStore()
  const { activeNav } = state
  return (
    <>
      <MainNav>
        <ScreenNav />
        <LanguageNav />
      </MainNav>
      <Route exact path="/map/:layer?">
        <ContentNav opened={!!activeNav}>
          <MapNav />
        </ContentNav>
      </Route>
      <Route exact path="/timeline/:year?">
        <ContentNav opened={!!activeNav}>
          <TimelineNav />
        </ContentNav>
      </Route>
    </>
  )
}

export default Navigation
